import {DomainObject} from 'shared/store';
import { action, computed, observable, makeObservable } from 'mobx';
import _ from 'lodash';

const BULK_EDIT_FIELDS = [
  'pay_rate',
  'manager'
];

class MassUpdate extends DomainObject {
  effectiveDate;
  comment;
  status;
  newValues = {};
  includedFields = [];
  bulkEditValues = {};
  massUpdateType;

  _relations = {
    _dates: ['effectiveDate'],
  };

  constructor(other) {
    super();

    makeObservable(this, {
      effectiveDate: observable,
      comment: observable,
      status: observable,
      newValues: observable,
      includedFields: observable,
      bulkEditValues: observable,
      massUpdateType: observable,
      addIncludedField: action,
      removeIncludedField: action,
      readOnly: computed,
      running: computed,
      complete: computed,
      bulkEditFields: computed
    });

    this.merge(other);
  }

  addIncludedField(field) {
    if (!this.includedFields.includes(field)) {
      this.includedFields.push(field);
    }
  }

  removeIncludedField(field) {
    if (this.includedFields.includes(field)) {
      this.includedFields.remove(field);
    }
  }

  get readOnly() {
    return this.status !== 'in_progress';
  }

  get running() {
    return this.status === 'running';
  }

  get complete() {
    return this.status === 'complete';
  }

  get bulkEditFields() {
    return _.intersection(this.includedFields, BULK_EDIT_FIELDS);
  }
}

export default MassUpdate;
